import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  buildDismissibleBannerKey,
  hideDismissibleBanner,
  isDismissibleBannerHidden
} from '../../utils/dismissibleBannerPrefs'
import { PremiumFeaturePill } from './PremiumInfoButton'

function PremiumFeaturePreview ({
  previewId,
  scope = 'global',
  title,
  description = '',
  overlayTitle = 'Scopri tutti i vantaggi Premium',
  overlayText = '',
  featureList = [],
  ctaLabel = 'Vai alla pagina Premium',
  className = '',
  children
}) {
  const storageKey = useMemo(
    () => buildDismissibleBannerKey(previewId, scope),
    [previewId, scope]
  )
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    setIsVisible(!isDismissibleBannerHidden(storageKey))
  }, [storageKey])

  const handleDismiss = () => {
    hideDismissibleBanner(storageKey)
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <section className={`premium-preview-card ${className}`.trim()}>
      <div className='premium-preview-card__head'>
        <div className='premium-preview-card__copy'>
          <span className='premium-preview-card__eyebrow'>
            Anteprima oscurata
          </span>
          <h4 className='premium-preview-card__title'>{title}</h4>
          {description && (
            <p className='premium-preview-card__description mb-0'>
              {description}
            </p>
          )}
        </div>

        <div className='premium-preview-card__head-actions'>
          <PremiumFeaturePill label='Premium' />
          <button
            type='button'
            className='premium-preview-card__close'
            aria-label='Chiudi anteprima premium'
            onClick={handleDismiss}
          >
            <i className='bi bi-x-lg' aria-hidden='true'></i>
          </button>
        </div>
      </div>

      <div className='premium-preview-card__viewport'>
        <div className='premium-preview-card__blurred'>{children}</div>

        <div className='premium-preview-card__overlay'>
          <div className='premium-preview-card__overlay-copy'>
            <small>Sblocca vantaggi Premium</small>
            <strong>{overlayTitle}</strong>
            {overlayText && <span>{overlayText}</span>}
          </div>

          {featureList.length > 0 && (
            <div className='premium-preview-card__chips'>
              {featureList.map(feature => (
                <span key={feature} className='premium-preview-card__chip'>
                  {feature}
                </span>
              ))}
            </div>
          )}

          <Link
            to='/premium'
            className='btn btn-sm btn-warning premium-preview-card__cta'
          >
            <i className='bi bi-stars me-1' aria-hidden='true'></i>
            {ctaLabel}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default PremiumFeaturePreview
